import GoogleCalendarView from '../components/GoogleCalendarView';

export default function CalendarPage() {
  return (
    <div className="flex flex-col flex-1 min-h-0">
      <GoogleCalendarView />
    </div>
  );
}
